// extracted by mini-css-extract-plugin
export var gif = "_kg-0";